// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabEmailsSearch-modulesearch__qel5b";
var _2 = "RequestProfileTabEmailsSearch-moduleskeleton__IQpld Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "search", _2 as "skeleton" }
